<template>
  <v-container fluid="fluid" grid-list-lg="grid-list-lg">
    <v-layout row="row" wrap="wrap">
      <v-flex xs12="xs12">
        <v-tabs right="right" slider-color="info" v-model="active">
          <v-tab class="text-transform-none">{{ $t('labels.prepaid') }}</v-tab>
          <v-tab class="text-transform-none">{{ $t('labels.promotion') }}</v-tab>
          <v-tabs-items touchless="touchless">
            <v-tab-item lazy="lazy">
              <ListByStore></ListByStore>
            </v-tab-item>
            <v-tab-item lazy="lazy">
              <PromotionListByStore></PromotionListByStore>
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
      </v-flex>
    </v-layout>
  </v-container>

</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ListByStore from '../../Wallet/components/ListByStore'
import PromotionListByStore from '../../Promotion/components/ListByStore'
import CreditCard from './CreditCard'

export default {
  data() {
    return {
      active: null,
    }
  },
  computed: {
    ...mapGetters('location', ['location'])
  },
  methods: {
    ...mapActions('global', ['sendEmail']),
  },
  components: {
    ListByStore,
    CreditCard,
    PromotionListByStore
  },
}
</script>

<style scoped>

</style>